import { FormSetting } from '@/form-settings/form-setting';
import { ControlType } from '@components/dynamic-form/control-type';
import { UploadControl } from '@components/dynamic-form/upload-input/upload-control';
import { ControlBase } from '@components/dynamic-form/control-base';
import { DropdownControl } from '@components/dynamic-form/dropdown/dropdown-control';
import { FormUploadMmssDocumentComponent } from './form-upload-document.component';
import { OptionSelect } from '@/models/option-select.model';

export class UploadMmssDocumentFormMeta extends FormSetting {
  private static rows: ControlBase[] = [];

  private static brands: OptionSelect[] = [];
  private static maggioriSconti: OptionSelect[] = [];
  private static fonteDocumentoMMSS: OptionSelect[] = [];
  private static tipologiaDocumentoMMSS: OptionSelect[] = [];
  private static isEditMode: boolean = false;

  public static setBrands(brands) {
    this.brands = brands;

    return this;
  }

  public static setFonteDocumentoMMSS(fonteDocumentoMMSS) {
    this.fonteDocumentoMMSS = fonteDocumentoMMSS;

    return this;
  }

  public static setMaggioriSconti(maggioriSconti) {
    this.maggioriSconti = maggioriSconti;

    return this;
  }

  public static setTipologiaDocumentoMMSS(tipologiaDocumentoMMSS) {
    this.tipologiaDocumentoMMSS = tipologiaDocumentoMMSS;

    return this;
  }

  public static setIsEditMode(isEditMode: boolean) {
    this.isEditMode = isEditMode;

    return this;
  }

  public static getMeta(): Array<any> {
    this.rows = [];

    // In modalità edit, aggiungi campi readonly per visualizzazione
    if (this.isEditMode) {
      this.addRowId();
      this.addRowFileName();
      this.addRowCreator();
      this.addRowCreated();
    }

    this.addRowFile();
    this.addRowFonte();
    this.addRowTipologia();
    this.addRowMarca();
    this.addRowAnno();
    this.addRowTrimestre();
    this.addRowMese();
    this.addRowMaggioriSconti();
    this.addRowDescrizione();

    return [
      {
        rows: this.rows,
        order: 1,
      },
    ];
  }

  private static addRowId() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'id';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'ID';
    inputsComponent.class = 'w-3/12';
    inputsComponent.required = false;
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowFileName() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'fileName';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Nome File';
    inputsComponent.class = 'w-9/12';
    inputsComponent.required = false;
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowCreator() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'creator';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Creato da';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = false;
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowCreated() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'created';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Data Creazione';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = false;
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowFile() {
    // In edit mode, il campo file non deve essere visibile
    if (this.isEditMode) {
      return;
    }

    const inputsComponent = {} as UploadControl;
    inputsComponent.key = 'file';
    inputsComponent.controlType = ControlType.uploadFile;
    inputsComponent.label = 'File';
    inputsComponent.class = 'w-full';
    inputsComponent.required = true;
    inputsComponent.accept = 'application/pdf';
    inputsComponent.uploadButton = 'Carica File';
    inputsComponent.multiple = false;
    inputsComponent.classToUse = FormUploadMmssDocumentComponent.name;
    inputsComponent.customAction = 'onFileSelected';

    this.rows.push(inputsComponent);
  }

  private static addRowDescrizione() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'descrizione';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Descrizione';
    inputsComponent.class = 'w-full';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowFonte() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'fonteDocumentoMMSS';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Fonte';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = false;
    inputsComponent.options = this.fonteDocumentoMMSS;

    this.rows.push(inputsComponent);
  }

  private static addRowTipologia() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'tipologiaDocumentoMMSS';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Tipologia';
    inputsComponent.class = 'w-6/12';
    inputsComponent.required = false;
    inputsComponent.options = this.tipologiaDocumentoMMSS;

    this.rows.push(inputsComponent);
  }

  private static addRowMaggioriSconti() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'maggioreSconto';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Maggiore sconto';
    inputsComponent.class = 'w-full';
    inputsComponent.required = false;
    inputsComponent.disabled = true;
    inputsComponent.options = this.maggioriSconti;

    this.rows.push(inputsComponent);
  }

  private static addRowMarca() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'marca';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Marca';
    inputsComponent.class = 'w-3/12';
    inputsComponent.required = true;
    inputsComponent.options = this.brands;

    this.rows.push(inputsComponent);
  }

  private static addRowAnno() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.key = 'anno';
    inputsComponent.controlType = ControlType.yearDate;
    inputsComponent.label = 'Anno';
    inputsComponent.class = 'w-3/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowMese() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'mese';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Mese';
    inputsComponent.class = 'w-3/12';
    inputsComponent.required = false;
    inputsComponent.options = [
      { key: 1, value: 'Gennaio' },
      { key: 2, value: 'Febbraio' },
      { key: 3, value: 'Marzo' },
      { key: 4, value: 'Aprile' },
      { key: 5, value: 'Maggio' },
      { key: 6, value: 'Giugno' },
      { key: 7, value: 'Luglio' },
      { key: 8, value: 'Agosto' },
      { key: 9, value: 'Settembre' },
      { key: 10, value: 'Ottobre' },
      { key: 11, value: 'Novembre' },
      { key: 12, value: 'Dicembre' },
    ];

    this.rows.push(inputsComponent);
  }

  private static addRowTrimestre() {
    const inputsComponent = {} as DropdownControl;
    inputsComponent.key = 'trimestre';
    inputsComponent.controlType = ControlType.dropdown;
    inputsComponent.label = 'Trimestre';
    inputsComponent.class = 'w-3/12';
    inputsComponent.required = true;
    inputsComponent.options = [
      { key: 'I', value: 'I' },
      { key: 'II', value: 'II' },
      { key: 'III', value: 'III' },
      { key: 'IV', value: 'IV' },
    ];

    this.rows.push(inputsComponent);
  }
}
